import React from 'react';
import './SideImg.css';
import SignInBannerUsers from '../../assets/suit.jpg';

const SideImage = ({ sideBannerSrc, sideBannerAlt }) => {
  return (
    <div className='sideimage__container'>
        <div className='sideimg'>
            <img src={sideBannerSrc} alt={sideBannerAlt} className='imgTag' loading="lazy" />  
        </div>   
    </div>
  )
}

export default SideImage;
